import { createRouter, createWebHistory } from 'vue-router';

import Login from '@/pages/Login';
import Tasks from '@/pages/Tasks';
import MyAssets from '@/pages/MyAssets';
import Check from '@/pages/Check';
import MyBoxes from '@/pages/MyBoxes';
import Downloads from '@/pages/Downloads';
import ConfusionMatrixPage from '@/pages/ConfusionMatrixPage';
import Projects from '@/pages/Projects';
import Settings from '@/pages/Settings';
import ImportData from '@/pages/ImportData';
import Instances from '@/pages/Instances';
import CheckModel from '@/pages/CheckModel';
import TrainPage from '@/pages/TrainPage';
import Validate from '@/pages/Validate';
import SettingsUsers from '@/pages/SettingsUsers';
import SettingsInstances from '@/pages/SettingsInstances';
import SettingsTrainConfigurations from '@/pages/SettingsTrainConfigurations';
import SettingsLabels from '@/pages/SettingsLabels';
import SettingsLabelGroups from '@/pages/SettingsLabelGroups';
import SettingsJobs from '@/pages/SettingsJobs';
import SettingsLabelSets from '@/pages/SettingsLabelSets';
import ProfileChooseAvatar from '@/pages/ProfileChooseAvatar';
import ProfileChangePassword from '@/pages/ProfileChangePassword';
import ProfileNotifications from '@/pages/ProfileNotifications';
import ProfileAuthentication from '@/pages/ProfileAuthentication';
import ProfileSegAny from '@/pages/ProfileSegAny';
import ProfileUserLimits from '@/pages/ProfileUserLimits';
import ProfileUpgradeSubscription from '@/pages/ProfileUpgradeSubscription';
import ProfilePaymentOverview from '@/pages/ProfilePaymentOverview';
import ProfileTrustedDevices from '@/pages/ProfileTrustedDevices';
import ProfileApiTokens from '@/pages/ProfileApiTokens';
import SuperAdminDashboard from '@/pages/SuperAdminDashboard';
import SuperAdminSlowQueries from '@/pages/SuperAdminSlowQueries';
import SuperAdminSlowRoutes from '@/pages/SuperAdminSlowRoutes';
import ModelPage from '@/pages/ModelPage';
import TryModelPage from '@/pages/TryModelPage.vue';
import DownloadModelPage from '@/pages/DownloadModelPage.vue';
import Unauthorized from '@/pages/Unauthorized';
import SettingsProject from '@/pages/SettingsProject';
import Project from '@/pages/Project';
import SettingsTasks from '@/pages/SettingsTasks';
import MyProfile from '@/pages/MyProfile';
import FrontPageDesignGallery from '@/pages/FrontPageDesignGallery';
import FrontPageDesignViewer from '@/pages/FrontPageDesignViewer';
import DesignDropbox from '@/components/front_page/designs/DesignDropbox.vue';
import TeamPage from '@/pages/TeamPage';
import Progress from '@/pages/Progress';
import Reports from '@/pages/Reports';
import ProjectOverview from '@/pages/ProjectOverview';
import SimpleMode from '@/pages/SimpleMode.vue';
import Auto from '@/pages/Auto.vue';
import AutoSuggestions from '@/pages/AutoSuggestions.vue';
import AutoSuggestionsOverview from '@/pages/AutoSuggestionsOverview.vue';
import ResetPassword from '@/pages/ResetPassword.vue';
import Success from '@/pages/Success.vue';
import ErrorPage from '@/pages/ErrorPage.vue';
import ConfirmEmail from '@/pages/ConfirmEmail.vue';
import store from '@/store/index';
import { applyProjectIdFromQuery } from '@/util/projectRoute';
import { getStoredToken, PUBLIC_ROUTE_NAMES } from '@/util/auth';
import { getBox21Api } from '@/util/apiHolder';

const routes = [
  { path: '/', component: DesignDropbox, name: 'FrontPage' },
  { path: '/designs', component: FrontPageDesignGallery, name: 'FrontPageDesignGallery' },
  {
    path: '/designs/:variantId',
    component: FrontPageDesignViewer,
    name: 'FrontPageDesignViewer',
    props: true,
  },
  { path: '/team', component: TeamPage, name: 'TeamPage' },
  { path: '/login', component: Login, name: 'Login' },
  { path: '/projects', component: Projects, name: 'Projects' },
  { path: '/project/:project_id', component: Project, name: 'Project' },
  { path: '/overview', component: ProjectOverview, name: 'ProjectOverview' },
  { path: '/simple', component: SimpleMode, name: 'SimpleMode' },
  { path: '/annotate', component: Tasks, name: 'Tasks' },
  { path: '/myassets', component: MyAssets, name: 'MyAsset' },
  { path: '/validate', component: Validate, name: 'Validate' },
  { path: '/myboxes', component: MyBoxes, name: 'MyBoxes' },
  { path: '/downloads', component: Downloads, name: 'Downloads' },
  { path: '/import', component: ImportData, name: 'Import' },
  { path: '/progress', component: Progress, name: 'Progress' },
  { path: '/reports', component: Reports, name: 'Reports' },
  { path: '/train/:model_type', component: TrainPage, name: 'Train' },
  { path: '/models', component: ModelPage, name: 'Models' },
  { path: '/try/:token', component: TryModelPage, name: 'TryModel', props: true },
  { path: '/download-model/:token', component: DownloadModelPage, name: 'DownloadModel', props: true },
  { path: '/settings', component: Settings, name: 'Settings' },
  { path: '/settings/users', component: SettingsUsers, name: 'SettingsUsers' },
  { path: '/settings/instances', component: SettingsInstances, name: 'SettingsInstances' },
  { path: '/settings/train-configurations', component: SettingsTrainConfigurations, name: 'SettingsTrainConfigurations' },
  { path: '/settings/labels', component: SettingsLabels, name: 'SettingsLabels' },
  { path: '/settings/tasks', component: SettingsTasks, name: 'SettingsTasks' },
  { path: '/settings/label-groups', component: SettingsLabelGroups, name: 'SettingsLabelGroups' },
  { path: '/settings/project', component: SettingsProject, name: 'SettingsProject' },
  { path: '/settings/jobs', component: SettingsJobs, name: 'SettingsJobs' },
  { path: '/settings/label-sets', component: SettingsLabelSets, name: 'SettingsLabelSets' },
  { path: '/profile/avatar', component: ProfileChooseAvatar, name: 'ProfileChooseAvatar' },
  { path: '/profile/change-password', component: ProfileChangePassword, name: 'ProfileChangePassword' },
  { path: '/profile/notifications', component: ProfileNotifications, name: 'ProfileNotifications' },
  { path: '/profile/authentication', component: ProfileAuthentication, name: 'ProfileAuthentication' },
  { path: '/profile/trusted-devices', component: ProfileTrustedDevices, name: 'ProfileTrustedDevices' },
  { path: '/profile/api-tokens', component: ProfileApiTokens, name: 'ProfileApiTokens' },
  { path: '/profile/seg-any', component: ProfileSegAny, name: 'ProfileSegAny' },
  { path: '/profile/user-limits', component: ProfileUserLimits, name: 'ProfileUserLimits' },
  { path: '/profile/upgrade-subscription', component: ProfileUpgradeSubscription, name: 'ProfileUpgradeSubscription' },
  { path: '/profile/payment-overview', component: ProfilePaymentOverview, name: 'ProfilePaymentOverview' },
  { path: '/auto', component: Auto, name: 'Auto' },
  { path: '/auto/suggestions', component: AutoSuggestions, name: 'AutoSuggestions' },
  { path: '/auto/suggestions-overview', component: AutoSuggestionsOverview, name: 'AutoSuggestionsOverview' },
  { path: '/instances', component: Instances, name: 'Instances' },
  { path: '/mostconfused', component: ConfusionMatrixPage, name: 'ConfusionMatrixPage' },
  { path: '/check/:asset_id', component: Check, name: 'Check' },
  { path: '/check-model/:asset_id', component: CheckModel, name: 'CheckModel' },
  { path: '/unauthorized', component: Unauthorized, name: 'Unauthorized' },
  { path: '/myprofile', component: MyProfile, name: 'MyProfile' },
  { path: '/superadmin', component: SuperAdminDashboard, name: 'SuperAdminDashboard' },
  { path: '/superadmin/slow-queries', component: SuperAdminSlowQueries, name: 'SuperAdminSlowQueries' },
  { path: '/superadmin/slow-routes', component: SuperAdminSlowRoutes, name: 'SuperAdminSlowRoutes' },
  { path: '/reset-password/:password_reset_token', component: ResetPassword, name: 'ResetPassword' },
  { path: '/reset-password/', component: ResetPassword, name: 'InitiateResetPassword' },
  { path: '/success', component: Success, name: 'Success' },
  { path: '/error', component: ErrorPage, name: 'Error' },
  { path: '/confirm/:token', component: ConfirmEmail, name: 'ConfirmEmail' },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    }
    return { top: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  applyProjectIdFromQuery(to, store);

  const host = window.location.host;
  if (
    !host.includes('box21.ai')
    && !host.includes('localhost')
    && !host.includes('box21.test')
    && !host.includes('box21.agouti')
    && (to.name === 'FrontPage' || to.name === 'FrontPageDesignGallery' || to.name === 'FrontPageDesignViewer' || to.name === 'TeamPage')
  ) {
    next({ name: 'Login' });
    return;
  }

  if (PUBLIC_ROUTE_NAMES.has(to.name)) {
    next();
    return;
  }

  if (!getStoredToken()) {
    next({
      name: 'Login',
      query: to.fullPath && to.fullPath !== '/login' ? { redirect: to.fullPath } : {},
    });
    return;
  }

  const api = getBox21Api();
  if (api) {
    const authenticated = await api.ensureSessionReady();
    if (!authenticated) {
      next({
        name: 'Login',
        query: to.fullPath && to.fullPath !== '/login' ? { redirect: to.fullPath } : {},
      });
      return;
    }
  }

  next();
});

export default router;
